import type { BackgroundImages } from "@gatsby-plugin-generic-page/fragments/backgroundImages"
import type { BadgeUdsContent } from "@gatsby-plugin-generic-page/fragments/badgeUds"
import type { ChangePeriodModal } from "@gatsby-plugin-generic-page/fragments/changePeriodModal"
import type { CtaElement } from "@gatsby-plugin-generic-page/fragments/ctaElement"
import type {
  UdsButtonConcept,
  UdsButtonVariant,
} from "@gatsby-plugin-generic-page/fragments/udsButton"
import type { ProductBoxBundle } from "~/fragments/bundle"
import type { SaleConfiguration } from "~/fragments/saleConfigurations"
import type { StaticPrice } from "~/fragments/staticPrice"
import type { SystemUdsIconsComponent } from "~/fragments/systemUdsIcons"

export enum ProductBoxButtonType {
  LINK = "link",
  PLAN = "plan",
}

export type ProductBoxParameter = {
  label: string
  isBoldLabel?: boolean
  value?: string
  isBoldValue?: boolean
  isInactive?: boolean
  tooltipText?: string
  icon?: SystemUdsIconsComponent
}

export type ProductBoxParameters = {
  id: string
  flatData: {
    name: string
    groupTitle?: string
    parameters: ProductBoxParameter[]
  }
}

export type ProductButton = {
  saleConfiguration: SaleConfiguration[]
  bundle?: ProductBoxBundle[]
  hideRenewalPrice?: boolean
  cta: CtaElement[]
  staticPrices?: StaticPrice[]
  additionalText?: string
  type: ProductBoxButtonType
  promoText?: string // TODO - ONESTORE-263
  concept: UdsButtonConcept
  variant: UdsButtonVariant
  planInputLabel?: string
  changePeriodModal?: ChangePeriodModal[]
}

export type ProductBox = {
  id: string
  flatData: {
    name: string
    title?: string
    descriptionText?: string
    label?: string
    labels?: BadgeUdsContent[]
    buttons: ProductButton[]
    parameters: ProductBoxParameters[]
    outerFooter?: CtaElement[]
    isTrialBox?: boolean
    buttonText?: string
    background?: BackgroundImages
  }
}
